import { render } from "./SelectRoute.vue?vue&type=template&id=5c15ccea&scoped=true"
import script from "./SelectRoute.vue?vue&type=script&lang=js"
export * from "./SelectRoute.vue?vue&type=script&lang=js"

import "./SelectRoute.vue?vue&type=style&index=0&id=5c15ccea&lang=scss&scoped=true"

import exportComponent from "/buddy/denhaagfietst-sterfietsroutes/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c15ccea"]])

export default __exports__